var exports = {
  "X": "BetaLabel__zux92D",
};

module.exports = exports;
